(() => {
  // Target ALL of your custom search inputs (desktop + mobile if you ever render both)
  const inputs = Array.from(document.querySelectorAll(".grizzly-search__input"));
  if (!inputs.length) return;

  const prefix = "Search For ";

  function startTyping(input) {
    const raw = input.getAttribute("data-type-phrases") || "";
    const phrases = raw.split(",").map(s => s.trim()).filter(Boolean);
    if (!phrases.length) return;

    let phraseIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = null;

    const userIsInteracting = () =>
      document.activeElement === input || (input.value && input.value.length > 0);

    const tick = () => {
      // If user is typing or field has value, keep placeholder blank and just wait
      if (userIsInteracting()) {
        input.placeholder = "";
        timer = setTimeout(tick, 200);
        return;
      }

      const word = phrases[phraseIndex];
      const shown = word.slice(0, charIndex);
      input.placeholder = prefix + shown;

      const typeSpeed = 55;
      const deleteSpeed = 35;
      const pauseEnd = 900;
      const pauseStart = 250;

      if (!deleting) {
        charIndex++;
        if (charIndex > word.length) {
          deleting = true;
          timer = setTimeout(tick, pauseEnd);
          return;
        }
        timer = setTimeout(tick, typeSpeed);
      } else {
        charIndex--;
        if (charIndex < 0) {
          deleting = false;
          charIndex = 0;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          timer = setTimeout(tick, pauseStart);
          return;
        }
        timer = setTimeout(tick, deleteSpeed);
      }
    };

    // Start / keep running
    tick();

    // If you click in, keep it empty
    input.addEventListener("focus", () => { input.placeholder = ""; });
  }

  inputs.forEach(startTyping);
})();